module.exports = __webpack_public_path__ + "img/icon-nav5_blue.0a2493f1.svg";